import { Link, useLocation } from "wouter";
import {
  LayoutDashboard,
  Plus,
  FileStack,
  BarChart3,
  Settings,
} from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function MobileBottomNav() {
  const isMobile = useIsMobile();
  const [location] = useLocation();

  const { data: session } = useQuery({
    queryKey: ["/api/auth/session"],
    queryFn: api.getSession,
    staleTime: 60000,
  });

  if (!isMobile) return null;

  const isPublicPage = location.startsWith("/sign/") || location.startsWith("/signing/") || location.startsWith("/embed/") || location === "/auth" || location.startsWith("/terms") || location.startsWith("/privacy") || location.startsWith("/dealform/") || location.startsWith("/webform/") || location.startsWith("/certificate/") || location.startsWith("/document-print/") || location.startsWith("/webform-print/");
  if (isPublicPage) return null;
  if (!session?.authenticated) return null;

  const navItems = [
    { icon: LayoutDashboard, label: "Home", href: "/" },
    { icon: FileStack, label: "Templates", href: "/templates" },
    { icon: Plus, label: "New", href: "/new-document", isAction: true },
    { icon: BarChart3, label: "Analytics", href: "/analytics" },
    { icon: Settings, label: "Settings", href: "/settings" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-card/95 backdrop-blur-lg border-t border-border safe-area-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around px-2 h-16">
        {navItems.map((item) => {
          const isActive = item.href === "/" ? location === "/" : location.startsWith(item.href);

          if (item.isAction) {
            return (
              <Link key={item.label} href={item.href}>
                <button
                  className="flex flex-col items-center justify-center -mt-5"
                  data-testid="mobile-nav-new-document"
                >
                  <div className="w-12 h-12 rounded-full bg-primary shadow-lg shadow-primary/30 flex items-center justify-center">
                    <item.icon className="w-6 h-6 text-white" strokeWidth={2.5} />
                  </div>
                  <span className="text-[10px] font-medium text-primary mt-0.5">{item.label}</span>
                </button>
              </Link>
            );
          }

          return (
            <Link key={item.label} href={item.href}>
              <button
                className={`flex flex-col items-center justify-center gap-0.5 min-w-[56px] py-1 transition-colors ${
                  isActive
                    ? "text-primary"
                    : "text-muted-foreground"
                }`}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                <item.icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
                <span className={`text-[10px] ${isActive ? "font-semibold" : "font-medium"}`}>{item.label}</span>
                {isActive && <div className="w-1 h-1 rounded-full bg-primary" />}
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
